<template>
    <modal @closed="handleClosed" :cancel-button-text="$t('CONFIRM_MODAL_OKAY')" class="pause-modal" custom-class="max-w-lg">
        <h2 class="pause-modal--heading" v-text="$t('PAUSE_DELIVERIES_CONFIRMATION_MODAL_YOUR_DELIVERIES')"></h2>
        <i v-if="loading" class="loader__loading-icon fa-spin"/>
        <div v-else>
            <p v-if="restartDate" v-text="restartDateString"></p>
            <p v-else v-text="$t('PAUSE_DELIVERIES_CONFIRMATION_MODAL_RESTART_THEM')"></p>
        </div>
    </modal>
</template>

<script>
import { format } from 'date-fns';
import Modal from '@/components/structure/Modal';

export default {
    name: 'PauseDeliveriesConfirmationModal',
    components: {
        Modal,
    },
    props: {
        subscriptionId: {
            required: true,
            type: Number,
        },
    },
    data() {
        return {
            loading: true,
        };
    },
    mounted() {
        this.$store.dispatch('subscription/fetchAllSubscriptions', true).then(() => {
            this.loading = false;
        });
    },
    computed: {
        subscription() {
            return this.$store.getters['subscription/getSubscriptionById'](this.subscriptionId);
        },
        restartDate() {
            return this.subscription.resume_date;
        },
        restartDateString() {
            const formattedDate = format(new Date(this.restartDate), 'do MMMM yyyy');
            return this.restartDate && this.$t('PAUSE_DELIVERIES_CONFIRMATION_MODAL_RESTART_DATE', { restartDate: formattedDate });
        },
    },
    methods: {
        handleClosed() {
            this.$emit('pause-deliveries-modal-closed');
        },
    },
};
</script>

<style lang="scss" scoped>
    .pause-modal {
        text-align: center;
    }

    .pause-modal--heading {
        font-size: 25px;
        line-height: 30px;
    }
</style>
